export type BackendSource = "localhost" | "shared-dev";

const isBackendSource = (value: unknown): value is BackendSource => value === "localhost" || value === "shared-dev";

function getBackendSourceStorageKey(): string {
  const surface = import.meta.env.MODE.startsWith("portal") ? "portal" : "staff";
  return `m360.backend-source.${surface}`;
}

export function readBackendSource(): BackendSource | null {
  try {
    const stored = window.localStorage.getItem(getBackendSourceStorageKey());
    if (!stored) return null;

    const parsed: unknown = JSON.parse(stored);
    return isBackendSource(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function persistBackendSource(source: BackendSource): void {
  try {
    window.localStorage.setItem(getBackendSourceStorageKey(), JSON.stringify(source));
  } catch {
    // Preference is best-effort; a failed write leaves the prior stored source in place after reload.
  }
}
